import { TableBodyCell } from '@pocketlaw/tetris';
import { StatusChip } from '../../../StatusChip';
import { TasksIds } from '../../../types';
export function StatusCell(props) {
    const { dueDate, status, taskId } = props;
    return (<TableBodyCell headers={TasksIds.status}>
      <StatusChip status={status} dueDate={dueDate} id={taskId}/>
    </TableBodyCell>);
}
